import $ from "jquery";

export const init = () => {
  let attempts = 0;

  /*--------------------------------------------------------------------------------------------------------------------------------------*/
  /*  Fragen und Antworten per Ajax im Klapper -------------------------------------------------------------------------------------------*/
  /*  Boostrap Collapsibles: Status (auf/zu) an Elternelement übergeben ------------------------------------------------------------------*/
  /*--------------------------------------------------------------------------------------------------------------------------------------*/

  $(".collapse").on("show.bs.collapse", function (e) {
    $(e.target).parents(".card").addClass("active");
  });
  $(".collapse").on("hide.bs.collapse", function (e) {
    $(e.target).parents(".card").removeClass("active");
  });

  const whenComplete = () => {
    if (attempts > 30) return;
    attempts += 1;
    if (process.env.NODE_ENV !== "production") {
      console.log(document.readyState);
    }
    if (document.readyState === "complete") {
      setTimeout(function () {
        $(".collapse").on("shown.bs.collapse", function (e) {
          let top = $(e.target).offset().top - 140;
          setTimeout(function () {
            $("html,body").animate({ scrollTop: top }, 500);
          }, 500);
        });
      }, 1000);
    } else {
      setTimeout(function () {
        whenComplete();
      }, 400);
    }
  };

  whenComplete();
};
